import { FC } from 'react';
import './Book.css';
import BasicCli from '../../../main/components/basicCli/BasicCli';

const Book: FC = () => {
  return (
    <>
      <BasicCli>
        <div>
          <h1>test</h1>
        </div>
      </BasicCli>
    </>
  );
};

export default Book;
